import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../adminconfig';
const API_URL = `${API_BASE_URL}/uploads`;

const Contact = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const adminToken = typeof window !== "undefined" ? localStorage.getItem("adminToken") : null;

    const [selectedMessage, setSelectedMessage] = useState(null);

    const openModal = (message) => {
        setSelectedMessage(message);
    };

    const closeModal = () => {
        setSelectedMessage(null);
    };

    useEffect(() => {
        const fetchForms = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/api/getintouch`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${adminToken}`,
                    },
                });

                setContacts(res.data);// ✅ store array from API
                setLoading(false);
            } catch (err) {
                console.error("Error fetching jobs:", err);
                setLoading(false);
            }
        };

        if (adminToken) {
            fetchForms();
        }
    }, [adminToken]);
    return (
        <div className="p-6 bg-white rounded-xl shadow-lg">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Careers Form Submissions</h2>

            <div className="overflow-x-auto">
                {loading ? (
                    <div className="text-center py-4">Loading submissions...</div>
                ) : (
                    <table className="min-w-full border text-sm text-left text-gray-700">
                        <thead className="bg-gray-100 text-xs uppercase">
                            <tr>
                                <th className="px-4 py-2 border">Full Name</th>
                                <th className="px-4 py-2 border">Email</th>
                                <th className="px-4 py-2 border">Mobile</th>
                                <th className="px-4 py-2 border">Position Applied For</th>
                                <th className="px-4 py-2 border">Message</th>
                                <th className="px-4 py-2 border">Resume</th>
                                <th className="px-4 py-2 border">Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contacts.length > 0 ? (
                                contacts.map((item, index) => (
                                    <tr key={item._id || index} className="hover:bg-gray-50">
                                        <td className="px-4 py-2 border">{item.fullName}</td>
                                        <td className="px-4 py-2 border">{item.emailAddress}</td>
                                        <td className="px-4 py-2 border">{item.mobileNumber}</td>
                                         <td className="px-4 py-2 border text-purple-600 font-semibold">{item.position}</td>
                                        <td className="px-4 py-2 border max-w-[250px]">
                                            {item.message ? (
                                                <div className="flex flex-col">

                                                    {/* Truncated preview */}
                                                    <p className="line-clamp-2">
                                                        {item.message}
                                                    </p>

                                                    {item.message.length > 100 && (
                                                        <button
                                                            onClick={() => openModal(item.message)}
                                                            className="text-purple-600 text-xs mt-1 text-left hover:underline"
                                                        >
                                                            Read More
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                "-"
                                            )}
                                        </td>

                                        <td className="px-4 py-2 border">
                                            {item.resume ? (
                                                <a
                                                    href={`${API_URL}/${item.resume}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-purple-600 underline"
                                                >
                                                    Download
                                                </a>
                                            ) : 'N/A'}
                                        </td>
                                        <td className="px-4 py-2 border">
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
            {selectedMessage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                    onClick={closeModal}
                >
                    <div
                        className="bg-white w-[90%] max-w-2xl rounded-xl shadow-xl p-6 relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={closeModal}
                            className="absolute top-3 right-3 text-gray-500 hover:text-black text-lg"
                        >
                            ✕
                        </button>

                        <h3 className="text-xl font-semibold mb-4">
                            Full Message
                        </h3>

                        <div className="max-h-[400px] overflow-y-auto whitespace-pre-wrap text-gray-700">
                            {selectedMessage}
                        </div>

                        <div className="mt-6 text-right">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Contact;
